import { useEffect } from 'react';

import { useEventsState, useEventsActions } from './EventsContext';

import { getEvents } from './restApi';

const EventsLoader = () => {
  const state = useEventsState();
  const { initializeState, onResponse, onError } = useEventsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getEvents({
      lastPageViewed: state?.lastPageViewed || 0,
      onResponse,
      onError,
    });
  }, []);

  return null;
};

export default EventsLoader;
